"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: '请选择时间'
};
var _default = locale;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/time-picker/locale/zh_CN.js
// module id = 694
// module chunks = 0